<template>
  <div class="page flex-col" style="margin: 0 auto;">
    <div class="outer1 flex-col justify-between">

      <div class="group1 flex-col">
        <img src="../../assets/img/SketchPng366ac14790b4150fd776c74ea548eeef4dacbdb3fa3d14c87c634929228e7e23.png"
          class="group1_bg" alt="" />
        <div class="bd1 flex-row" style="background:none;">
          <img class="pic1" referrerpolicy="no-referrer" src="../../assets/img/logo (2).png" />
          <a href="http://www.chinanurse.cn/"><span class="info1">首页</span></a>
          <a href="http://www.chinanurse.cn/"><span class="word1">国内课程</span></a>
          <a href="http://www.chinanurse.cn/"><span class="info2">国际课程</span></a>
          <span class="word2">壹护聘书</span>
          <a href="http://exam-pc.chinanurse.cn/#/login"><span class="word3">考试中心</span></a>
          <a href="http://www.chinanurse.cn/certificate"><span class="info3">证书查询</span></a>
          <a href="http://www.chinanurse.cn/download"><span class="info3">APP下载</span></a>
        </div>
        <div class="bd2 flex-row">
          <div class="bd3 flex-col"></div>
        </div>
      </div>

      <div class="group2 flex-col">
        <img src="../../assets/img/SketchPngadc841dac17cf5aa8eb4d24afe37e6dfa4be96214779aef3c62050aa6dfcdb59.png"
          class="group1_bg" alt="">
        <div class="outer2 flex-row justify-between">
          <div class="box1 flex-col">
            <div class="group3 flex-row justify-between">
              <img class="img1" referrerpolicy="no-referrer"
                src="../../assets/img/SketchPng0322a1d55d971f513afec680bbc4bd3776e37b15c6c8a0f6bd5d58989306dc2a.png" />
              <div class="block1 flex-col"></div>
            </div>
            <span class="infoBox1">
              壹护聘书隶属于中国护士网旗下专业医护人才招聘平台，
              <br />
              提供护理人才招聘、护理专业人才管理培训等服务。
            </span>
            <div class="group4 flex-col"><span class="word4">高端护理人才对接平台</span></div>
          </div>

          <div class="box2 flex-col" v-if="idx == 0">
            <img src="../../assets/img/SketchPngc036d6550dd29067ca226084e0a527f2036fb371d319d5b629a013e7e9679b3e.png"
              class="group1_bg" alt="">
            <div class="outer3 flex-col">
              <div class="layer1 flex-row justify-between">
                <span @click="idx = 0" style="cursor:pointer;" class="word5">密码登录</span>
                <span @click="idx = 1" style="cursor:pointer;" class="info4">短信登录</span>
              </div>
              <div class="layer2 flex-col"></div>
              <el-input class="layer3 flex-col" v-model="phone" placeholder="请输入手机号"></el-input>
              <el-input type="password" class="layer4 flex-col" v-model="password" placeholder="请输入密码"></el-input>
              <button @click="loginfun()" class="layer5 flex-col"><span class="word6">立即登录</span></button>
            </div>
            <div class="outer4 flex-col">
              <img src="../../assets/img/SketchPng8cc12d86ab27724e967408d96e9644d9bb39c4986cbf505e6daa8fac38b428d5.png"
                class="group1_bg" alt="">
              <span class="info6">合作账号登录</span>
              <img class="pic2" referrerpolicy="no-referrer"
                src="../../assets/img/SketchPngb6c95d52234bc0dcf9d3d06623cc8eb6d237a8c451b75e0ce634f53f51bd978e.png" />
            </div>
          </div>

          <div class="main22 flex-col" v-if="idx == 1">
            <img src="../../assets/img/SketchPngc036d6550dd29067ca226084e0a527f2036fb371d319d5b629a013e7e9679b3e.png"
              class="group1_bg" alt="">
            <div class="group11 flex-col">
              <div class="outer22 flex-row justify-between">
                <span @click="idx = 0" style="cursor:pointer;" class="txt3">密码登录</span>
                <span @click="idx = 1" style="cursor:pointer;" class="word55">短信登录</span>
              </div>
              <div class="outer33 flex-col"></div>
              <el-input class="layer3 flex-col" v-model="telState" placeholder="请输入手机号"></el-input>
              <div class="outer55 flex-col">
                <el-input v-model="codeState" placeholder="短信验证码"></el-input>
                <div class="group22 flex-row justify-between">
                  <button v-if="numState == 60" class="block22 flex-col" @click="onClick_1">
                    <img
                      src="../../assets/img/SketchPng9c702a4ec8ac2809ae5fb2b762fc45a9d056713957f353860803323adbc5f1c7.png"
                      class="group1_bg" style="z-index: 0;" alt="">
                    <span class="word88">获取验证码</span></button>
                  <button v-if="numState != 60" style="background: #b1b1b1;" disabled class="block22 flex-col"><span
                      style="margin-left: 8px;" class="word88">{{ `${numState}S后重新发送` }}</span></button>
                </div>
              </div>

              <button class="outer66 flex-col" @click="onClick_2"><span class="word99">立即登录</span></button>
            </div>
            <div class="group33 flex-col">
              <img src="../../assets/img/SketchPng8cc12d86ab27724e967408d96e9644d9bb39c4986cbf505e6daa8fac38b428d5.png"
                class="group1_bg" alt="">
              <span class="txt44">合作账号登录</span>
              <img class="pic22" referrerpolicy="no-referrer"
                src="../../assets/img/SketchPngb6c95d52234bc0dcf9d3d06623cc8eb6d237a8c451b75e0ce634f53f51bd978e.png" />
            </div>
          </div>

        </div>
      </div>
    </div>
    <div class="outer5 flex-col">
      <div class="box3 flex-row">
        <div class="mod1 flex-col">
          <img class="img2" referrerpolicy="no-referrer"
            src="../../assets/img/SketchPng07814e539244c4d832bfb1bbe2ac7cff2b735b4c5d9fbbbb41e09c7e8d8c3cfc.png" />
        </div>
        <div class="mod2 flex-col justify-between">
          <div class="section1 flex-col"><span class="info7">公司简介</span></div>
          <div class="section2 flex-col">
            <img src="../../assets/img/SketchPng0eb02226ca68e9858231db2513cd921d1266f35f3c9f6e18fff95e47a91f20a9.png"
              class="group1_bg" alt="">
            <span class="infoBox2">
              自2004年5月12日中国护士网成立以来，提供护士专业晋升、护理科研、护士招聘、护士证考试等服务，致力于推动中国560万护士行业发展。
            </span>
          </div>
        </div>
        <div class="mod3 flex-col"></div>
        <div class="mod4 flex-col justify-between">
          <div class="bd4 flex-row justify-between">
            <div class="main1 flex-col justify-between">
              <img class="img3" referrerpolicy="no-referrer" src="../../assets/img/app.png" />
              <div class="bd5 flex-col"><span class="word7">护士网app</span></div>
            </div>
            <div class="main1 flex-col justify-between">
              <img class="img3" referrerpolicy="no-referrer" src="../../assets/img/xiaochengxu.jpg" />
              <div class="bd5 flex-col"><span class="word7">壹护聘书小程序</span></div>
            </div>
            <!-- <img class="img4" referrerpolicy="no-referrer" src="../../assets/img/xiaochengxu.jpg" />
            <div class="main2 flex-col"><span class="word8">壹护聘书小程序</span></div> -->
          </div>
          <div @click="create()" style="cursor:pointer;user-select: none;" class="bd6 flex-col"><span
              class="txt2">立即合作</span></div>
        </div>
      </div>

      <Footer></Footer>
    </div>

    <el-dialog :visible.sync="centerDialogVisible" width="406px" center :show-close="false">
      <div class="dialog-title img4s">
        <img class="img4s" src="../../assets/img/shouqianshou.png" srcset="" :style="{
          width: '390px',
          position: 'absolute',
          right: '8px',
          top: '25px',
        }" />
        <img class="close-icon" src="../../assets/img/close.png" alt="" srcset="" :style="{
          width: '26px',
          position: 'absolute',
          right: '15px',
          top: '12px',
        }" @click="centerDialogVisible = false" />
      </div>
      <el-form :model="form">
        <el-form-item>
          <h2>合作申请</h2>
        </el-form-item>
        <el-form-item>
          <h3 class="el-icon-first-aid-kit">预期招聘岗位</h3>

          <div class="formCss">
            <el-checkbox-group v-model="positionTypeIds" size="medium">
              <el-checkbox-button style="margin: 10px 0 0 10px;" v-for="item in poitionTypes" :label="item.id"
                :key="item.id" :value="item.id">{{
                  item.positionType
                }}</el-checkbox-button>
            </el-checkbox-group>
          </div>
        </el-form-item>
        <el-form-item label="机构名称" :label-width="formLabelWidth">
          <el-input v-model="form.companyName" placeholder="请输入机构名称" autocomplete="off" style="width: 90%"></el-input>
        </el-form-item>
        <el-form-item label="联系人　" :label-width="formLabelWidth">
          <el-input v-model="form.contactman" placeholder="请输入联系人姓名" style="width: 90%"></el-input>
        </el-form-item>
        <el-form-item label="联系电话" :label-width="formLabelWidth">
          <el-input v-model="form.phone" placeholder="请输入联系人电话" style="width: 90%">
            <el-button type="text" slot="suffix" @click="phoneVerification" :disabled="this.buttonState">{{ codeText }}
            </el-button>
          </el-input>
        </el-form-item>
        <el-form-item label="验证码　" :label-width="formLabelWidth">
          <el-input type="text" v-model="form.smsCode" placeholder="请输入验证码" style="width: 90%"></el-input>
        </el-form-item>
      </el-form>
      <div class="dialog-footer">
        <el-button class="homeBut" type="primary" style="background-color: #409EFF;border-color: #409EFF;height:40px;"
          @click="subLogin" :disabled="!isEdit">提 交</el-button>
      </div>
    </el-dialog>
    <div>
      <el-dialog title="" :visible.sync="centerDialog" width="300px" :close-on-click-modal="false" :show-close="false">
        <div class="graphical">
          <div class="alert_title">请输入图形验证码</div>
          <input type="text" v-model.trim="captcha" placeholder="请输入验证码" maxLength="4" />
          <div class="imag_code">
            <img :src="imgUrl" alt="" @click="updateImg" />
            <p @click="updateImg">点击图片刷新</p>
          </div>
          <div class="btn_group">
            <button @click="centerDialog = false">取消</button>
            <button @click="determine">确认</button>
          </div>
        </div>
      </el-dialog>
    </div>
    <div>
      <el-dialog :visible.sync="innerVisible" width="406px" :show-close="false" center>
        <div class="dialog-title img4s">
          <img class="img4s" src="../../assets/img/shouqianshou.png" alt="" srcset="" :style="{
            width: '390px',
            position: 'absolute',
            right: '8px',
            top: '25px',
          }" />
          <img class="close-icon" src="../../assets/img/close.png" alt="" srcset="" :style="{
            width: '26px',
            position: 'absolute',
            right: '30px',
            top: '18px',
          }" />
        </div>
        <img class="img5" src="../../assets/img/succeed.png" alt="" srcset="" />
        <el-form :model="form">
          <div>
            <h2>提交成功</h2>
          </div>
          <div>
            <P class="word-v-middle">您的专属服务顾问将在<i>24</i>小时内与您取得联系请保持联系方式畅通</P>
          </div>
        </el-form>
        <el-button class="homeBut" style="display: block; margin: 25px 0px 10px 20px" type="primary"
          v-loading.fullscreen.lock="fullscreenLoading" @click="succeed">确 认</el-button>
      </el-dialog>
    </div>

    <el-dialog title="" :visible.sync="yzmistf" width="300px" :close-on-click-modal="false" :show-close="false">
      <div class="graphical">
        <div class="alert_title">请输入图形验证码</div>
        <input type="text" v-model.trim="inputImgState" placeholder="请输入验证码" maxLength="4" />
        <div class="imag_code">
          <img :src="codeUrl" alt="" @click="_refreshCode" />
          <p @click="_refreshCode">点击图片刷新</p>
        </div>
        <div class="btn_group">
          <button @click="yzmistf = false">取消</button>
          <button @click="_getSendCode">确认</button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import qs from 'qs'
import CourseCard from './courseCard.vue'
import GoAbroad from './goAbroad.vue'
import CourseCatalogue from './courseCatalogue.vue'
import '../../assets/js/jsencrypt.min.js'
import Footer from "../../components/Footer/Footer";

export default {
  components: {
    CourseCard,
    GoAbroad,
    CourseCatalogue,
    Footer
  },
  head() {
    return {
      title: '壹护聘书网',
    }
  },
  data() {
    return {
      phone: "",
      password: "",
      idx: 0,
      bodyWidth: '',
      // iframeSrc: '',
      courseType: '',
      type: '',
      // courseList: [],
      newsList: [],
      poitionTypes: '',
      positionTypeIds: [],
      positionType: '',
      leftNews: [],
      codeText: '发送验证码',
      time: 60,
      centerDialogVisible: false,
      centerDialog: false,
      captcha: '',
      flag: true,
      innerVisible: false,
      form: {
        companyName: '',
        contactman: '',
        phone: null,
        rightFirst: [],
        rightTwo: [],
        smsCode: null,
        delivery: false,
        type: [],
        resource: '',
        desc: '',
      },
      imgUrl: '',
      buttonState: false,
      formLabelWidth: '75px',
      fullscreenLoading: false,
      isEdit: true,

      yzmistf: false,
      telState: '',
      codeState: '',
      codeUrl: '',
      inputImgState: "", //图形验证码
      codeState: "", //短信验证码
      numState: 60,
      timer: null,
    }
  },
  mounted() {
    // this._refreshCode();
    // this.updateImg();
    this.bodyWidth = document.body.clientWidth
    window.addEventListener(
      'resize',
      async () => {
        this.bodyWidth = document.body.clientWidth
      },
      false
    )
  },
  methods: {
    /** @name 刷新图形验证码 */
    _refreshCode() {
      this.$apiFun.captcha().then((res) => {
        let blob = new Blob([res], { type: "image/png" });
        let url = window.URL.createObjectURL(blob);
        this.codeUrl = url;
      })
    },
    updateImg() {
      this.$apiFun.captcha().then((res) => {
        let blob = new Blob([res], { type: "image/png" });
        let url = window.URL.createObjectURL(blob);
        this.imgUrl = url;
      })
    },
    _getSendCode() {
      if (this.telState !== "") {
        this.$apiFun._sendSms(({
          tel: JSON.parse(this.telState),
        })).then((res) => {
          if (res.code === 200) {
            this._sendCode();
            this.$message({
              message: "发送成功,请注意查收手机验证码！",
              type: "success",
            });
          } else {
            this.$message({
              message: res.msg,
              type: "warning",
            });
          }
        })
      }
    },
    onClick_1() {
      if (!/^1[3456789]\d{9}$/.test(this.telState)) {
        this.$message({
          message: '手机号码格式不正确',
          type: 'error',
        })
        return false
      }
      this._getSendCode()
    },
    onClick_2() {
      if (this.telState === "") {
        this.$message({
          message: "请输入手机号！",
          type: "warning",
        });
        return;
      }
      if (this.codeState === "") {
        this.$message({
          message: "请输入短信验证码！",
          type: "warning",
        });
        return;
      }
      const reg = /^1[3456789]\d{9}$/;
      if (!reg.test(this.telState)) {
        this.$message({
          message: "手机号格式不正确",
          type: "warning",
        });
        return;
      }

      this.$apiFun._loginBySms(({
        tel: this.telState,
        smsCode: this.codeState,
        deviceType: 'yhpspc',
        registerChannel: 'register',
        source: 'yhpspc',

      })).then((res) => {
        if (res.code === 200) {
          this.$store.state.stidx = 0;
          localStorage.setItem("store", this.$store.state.stidx);
          localStorage.setItem("Authorization", res.data.token);
          this.$apiFun.CompanyManagementCenter(qs.stringify()).then((data) => {
            if (data.code === 200) {
              if (data.data.name == undefined) {
                this.$message.error("您不是机构会员！");
                setTimeout(() => {
                  this.loading.close();
                  this.$router.push({ name: 'login' });
                }, 2000);
              } else {
                this.$message({
                  message: "登录成功！",
                  type: "success",
                });
                this.$router.push({ path: '/home' });
              }
            } else {
              this.$message.error("您不是机构会员！");
              setTimeout(() => {
                this.loading.close();
                this.$router.push({ name: 'login' });
              }, 2000);
            }
          })
        } else {
          this.$message({
            message: res.msg,
            type: "warning",
          });
          if (res.code === 300) {
            this.codeState = "";
          }
        }
      })
    },
    _sendCode() {
      let timer_num = 60;
      this.timer = setInterval(() => {
        timer_num--;
        this.numState = timer_num;
        if (timer_num <= 0) {
          clearInterval(this.timer);
          this.numState = 60;
        }
      }, 1000);
    },
    loginfun() {
      this.$apiFun._getLoginRsaKey(
      ).then((res) => {
        if (res.code != 200) {
          return false;
        }
        let keyObj = {
          publicKey: res.data.publicKey,
          rsakey: res.data.rsakey,
        };
        let passwd = this.getRsaPassword(keyObj.publicKey, this.password); //获取秘钥

        this.$apiFun._login({
          tel: this.phone,
          passwd: passwd,
          deviceType: 'yhpspc',
          rsakey: keyObj.rsakey,
        }).then((resu) => {
          if (resu.code == 200) {
            localStorage.setItem("Authorization", resu.data.token);
            this.$message({
              message: "登录成功！",
              type: "success",
            });
            this.$router.push({ name: 'home' });
          } else { this.$message.error({ message: resu.msg }); }
        })
      });
    },
    getRsaPassword(publicKey, passwd) {
      let publickey = publicKey;
      let encrypt = new JSEncrypt();
      encrypt.setPublicKey(publickey);
      return encrypt.encrypt(passwd);
    },
    //输入验证码和手机后登录
    async subLogin() {
      let phone = this.form.phone
      let smsCode = this.form.smsCode

      if (!this.form.companyName) {
        this.$message({
          message: '请输入机构名称',
          type: 'warning',
        })
        return false
      }
      if (!this.form.contactman) {
        this.$message({
          message: '请输入联系人',
          type: 'warning',
        })
        return false
      }

      if (!this.form.phone) {
        this.$message({
          message: '请输入手机号码',
          type: 'warning',
        })
        return false
      }
      if (!this.form.smsCode) {
        this.$message({
          message: '请输入验证码',
          type: 'warning',
        })
        return false
      }
      var lengthInt = this.positionTypeIds.length - 1
      if (lengthInt < 0) {
        this.$message({
          message: '请输入预期招聘岗位',
          type: 'warning',
        })
        return false
      }

      var positionTypeIds = ''
      for (var index in this.positionTypeIds) {
        if (positionTypeIds === '') {
          positionTypeIds = this.positionTypeIds[index]
        } else {
          positionTypeIds = positionTypeIds + ',' + this.positionTypeIds[index]
        }
      }
      this.$apiFun.officialSubmit(qs.stringify({
        phone: this.form.phone,
        positionTypeIds: positionTypeIds,
        companyName: this.form.companyName,
        contactman: this.form.contactman,
        smsCode: this.form.smsCode,
      })).then((data) => {
        if (data.code == 200) {
          this.centerDialogVisible = false
          this.innerVisible = true
        } else {
          this.$message({
            message: data.msg,
            type: 'warning',
          })
        }
      })

    },
    succeed() {
      window.location.reload()
      this.innerVisible = false
    },
    //验证手机号正确并打开弹窗
    phoneVerification() {
      if (!/^1[3456789]\d{9}$/.test(this.form.phone)) {
        this.$message({
          message: '手机号码格式不正确',
          type: 'error',
        })
        return false
      }
      this.$apiFun._sendSms(({
        tel: this.form.phone
      })).then((data) => {
        if (data.code == 200) {
          this.$message({
            message: "发送成功,请注意查收手机验证码！",
            type: "success",
          });
          this.buttonState = true
          this.codeText = `60s后重新发送`
          let setTime = setInterval(() => {
            if (this.time > 0) {
              this.time--
              this.codeText = `${this.time}s后重新发送`
            } else {
              this.codeText = '重新发送'
              this.buttonState = false
              clearInterval(setTime)
            }
          }, 1000)
        } else {
          this.$message.error(data.msg)
        }
      })
      // this.centerDialog = true
      // this.updateImg() //每次打开弹窗会刷新图片验证码
    },
    // 判断验证码是否正确
    async determine() {
      this.$apiFun.sendSms(qs.stringify({
        tel: this.form.phone,
        captchaCode: this.captcha,
        companyName: this.form.companyName,
      })).then((data) => {
        if (data.code == 200) {
          this.centerDialog = false
          this.buttonState = true
          this.codeText = `60s后重新发送`
          let setTime = setInterval(() => {
            if (this.time > 0) {
              this.time--
              this.codeText = `${this.time}s后重新发送`
            } else {
              this.codeText = '重新发送'
              this.buttonState = false
              clearInterval(setTime)
            }
          }, 1000)
        } else {
          this.$message.error('图形验证码错误或已失效！')
        }
      })
    },
    create() {
      // console.log(this.$route.fullPath);

      this.centerDialogVisible = true
      // this.$apiFun.positionTypeSearch().then((data) => {
      //   if (data.code == 200) {
      //     this.poitionTypes = data.data
      //   }
      // })

    },
    onSubmit() {
      this.post()
    },
    post() {
      var that = this

      if (!this.form.smsCode) {
        this.$message({
          message: '请输入验证码',
          type: 'warning',
        })
        return false
      }
    },
    getNewsList(id) {
      this.$apiFun.getNewsListByTime(qs.stringify({
        search_word: '',
        search_time: new Date().getTime(),
        lable_id: id,
      })).then((data) => {
        if (data.code == 1) {
          return data.data
        } else {
          return []
        }
      })
    },
    toNewsList(pathName) {
      this.$router.push({ name: pathName })
    },
    moreCourses(type, status) {
      this.courseType = type
      this.isDiag = status
    },
  },
}
</script>
<style lang="less" scoped>
a {
  text-decoration: none;
  color: #333;
}

a:hover,
a:visited,
a:link,
a:active {
  color: #333;
  // 设置使所有a标签的四种状态都和本身颜色保持一致，样式代码自己写
}

body::-webkit-scrollbar {
  width: 0;
}

.el-carousel__indicators {
  bottom: 130px;
  background-color: rgb(182, 181, 181);
  padding: 0 10px;
  border-radius: 10px;

  .el-carousel__button {
    width: 40px;
    height: 8px;
    border-radius: 4px;
  }
}

.home {
  width: 100vw;
  min-width: 1280px;

  .img {
    width: 100%;
    height: 540px;
    /*display: flex;*/
    justify-content: center;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .linkImg {
    cursor: pointer;
  }

  .box-size {
    height: 360px;
  }

  .zixun {
    background-color: #fff;
    position: relative;

    .news {
      position: absolute;
      top: -120px;
      left: 0;
      z-index: 99;
      display: flex;
      background-color: #fff;
      justify-content: center;
      padding: 50px 0;
      border-radius: 0 80px 0 0;

      .news-content {
        width: 1280px;
        display: flex;
        justify-content: flex-start;

        .first-picture {
          width: 350px;
          height: 292px;
          position: relative;
          border-radius: 8px;
          background-color: rgba(250, 250, 254, 1);
          overflow: hidden;

          /*cursor: pointer;*/
          img {
            width: 100%;
            height: 100%;
          }

          .title {
            position: absolute;
            left: 0;
            bottom: 0;
            width: 320px;
            height: 47px;
            line-height: 47px;
            background-color: rgba(255, 255, 255, 0.8);
            color: rgba(68, 68, 82, 100);
            font-size: 16px;
            text-align: center;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            padding: 0 20px;
          }
        }

        .hotspot {
          width: 440px;
          margin: 0 70px;

          .hotspot-title {
            display: flex;
            justify-content: space-between;
            align-items: flex-end;
            padding-bottom: 14px;

            .title {
              font-size: 16px;
              font-family: PingFangSC-Semibold, PingFang SC;
              font-weight: 600;
              color: #444452;
              line-height: 24px;
              width: 92px;
              height: 26px;
              background: #f2f2f2;
              border-radius: 0px 22px 22px 0px;
              text-align: center;
            }
          }

          .slow {
            width: 248px;
            height: 248px;
            background: #ffffff;
            border-radius: 4px;
            border: 1px solid #f2f2f2;

            p {
              font-size: 15px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #444452;
              line-height: 30px;
              padding: 13px 13px 25px 26px;
              /*&:hover {*/
              /*  color: #3263ff;*/
              /*}*/
            }
          }
        }

        .information {
          margin-top: -80px;
          width: 380px;
          display: flex;
          align-items: center;
          text-align: center;

          img {
            width: 180px;
            height: 180px;
            margin-right: 40px;
            /*cursor: pointer;*/
          }

          p {
            width: 180px;
            height: 40px;
            background: #f2f2f2;
            font-size: 16px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #000000;
            line-height: 40px;
          }

          .first {
            width: 300px;
            height: 50px;
            border-radius: 24px;
            margin-left: -480px;
            margin-top: 340px;
          }
        }
      }
    }
  }

  .brief-introduction {
    display: flex;
    justify-content: center;

    img {
      width: auto;
    }
  }
}

.verification-code {
  display: flex;
  justify-content: space-between;

  .el-input {}

  .el-input__inner {
    flex: 2;
  }
}

.img4s {
  width: 100%;
  height: 95px;
  margin: -17px 0 0 0;
}

.img5 {
  width: 124px;
  height: 124px;
  margin: 6px 0 0 115px;
}

h2 {
  font-size: 18px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: bold;
  color: #271D1D;
  line-height: 30px;
  text-align: center;
}

.homeBut {
  margin-top: 20px;
  border-radius: 24px;
  width: 90%;
  color: rgba(255, 255, 255, 1);
}

.word-v-middle {
  width: 85%;
  display: block;
  color: #666666;
  font-size: 14px;
  line-height: 24px;
  text-align: center;
  overflow: hidden;
  margin: 6px 0 0 8%;
}

p:first-child i {
  color: #ff0000;
  font-weight: bold;
}

.dialog-footer {
  text-align: center;
  border-radius: 8px;
}

dialog_headerbtn .el-dialog__close {
  color: #ffff;
}

/deep/ .el-dialog {
  border-radius: 10px;
}

.formCss /deep/ .el-checkbox-button__inner,
.formCss /deep/ .el-checkbox-button:first-child .el-checkbox-button__inner {
  border: 1px solid #dcdfe6;
  border-radius: 6px !important;
  margin: 10px 0 0 10px;
}

.graphical {
  text-align: center;

  .alert_title {
    font-size: 16px;
    color: #000;
    font-weight: bold;
    margin-bottom: 15px;
  }

  input {
    width: calc(100% - 10%);
    height: 48px;
    background: #f4f8f9;
    border-radius: 6px;
    margin-bottom: 20px;
    border: none;
    padding: 0 5%;
    caret-color: green;
  }

  .imag_code {
    display: flex;
    justify-content: flex-start;
    align-items: center;

    img {
      width: 100px;
      cursor: pointer;
    }

    p {
      text-align: center;
      margin: 0 0;
      padding-left: 10px;
      font-size: 14px;
      cursor: pointer;
    }
  }

  .btn_group {
    display: flex;
    border-top: 1px solid #ccc;
    margin-top: 20px;
    margin-bottom: -15px;

    button {
      flex: 1;
      font-size: 16px;
      color: #000;
      line-height: 40px;

      &:first-child {
        border-right: 1px solid #ccc;
      }
    }
  }
}
</style>
<style scoped lang="css" src="../../assets/css/index.css" />
<style scoped lang="css" src="../../assets/css/common.css">